import React from "react";
import UpdateSection from "../../components/blog/UpdateSection";
import SectionCards from "../../components/blog/SectionCards";
import SEO from "../../components/SEO";

export const Blogs = () => {
  return (
    <div>
      <SEO
        title="Blog MSIT Conseil - Actualités et Articles sur la Transformation Digitale"
        description="Découvrez les derniers articles et actualités de MSIT Conseil sur la transformation digitale, l'intelligence artificielle, la data et les services technologiques."
        keywords="blog MSIT, articles transformation digitale, actualités MSIT, intelligence artificielle, data"
        url="https://www.msit-conseil.fr/blogs"
        breadcrumbs={[
          { name: "Accueil", url: "https://www.msit-conseil.fr/" },
          { name: "Blog", url: "https://www.msit-conseil.fr/blogs" }
        ]}
      />
      <UpdateSection />
      <SectionCards />
    </div>
  );
};
